module.exports = __webpack_public_path__ + "static/media/slice1.865a6cd1.png";